import { MutationTree } from "vuex";
import { ConfigState } from "./types";
export const mutations: MutationTree<ConfigState> = {
	setadmin(state, payload: boolean) {
		state.admin = payload;
	},
	settoken(state, payload: string) {
		state.token = payload;
	},
	setuser(state, payload: string) {
		state.user = payload;
	},
	setapiroot(state, payload: string) {
		state.apiroot = payload;
	},
	setaccountid(state, payload: number) {
		state.accountid = payload;
	},
	setcurrentid(state, payload: number) {
		state.currentid = payload;
	},
	setthumburl(state, payload: string) {
		state.thumburl = payload;
	},
	setstore(state, payload: string) {
		state.store = payload;
	}
};
